//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export enum KEYS {
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP = 'ArrowUp',
  BACKSPACE = 'Backspace',
  COMMA = ',',
  ENTER = 'Enter',
  ESC = 'Escape',
  SHIFT = 'Shift',
  SPACE = ' ',
  TAB = 'Tab',
}

export const KEYCODES = {
  [KEYS.ARROW_DOWN]: 40,
  [KEYS.ARROW_LEFT]: 37,
  [KEYS.ARROW_RIGHT]: 39,
  [KEYS.ARROW_UP]: 38,
  [KEYS.BACKSPACE]: 8,
  [KEYS.COMMA]: 188,
  [KEYS.ENTER]: 13,
  [KEYS.ESC]: 27,
  [KEYS.SHIFT]: 16,
  [KEYS.SPACE]: 32,
  [KEYS.TAB]: 9,
};
